import { listAnatomy } from "@chakra-ui/react/anatomy";
import { defineSlotRecipe } from "@chakra-ui/react/styled-system";

// "row" lays each item out as an icon, a label and trailing actions, for
// entity lists such as a contact's vehicles.
export default defineSlotRecipe({
  slots: listAnatomy.keys(),
  variants: {
    variant: {
      row: {
        root: {
          gap: "0",
        },
        item: {
          display: "grid",
          gridTemplateColumns: "auto minmax(0, 1fr) auto",
          justifyItems: "start",
          alignItems: "center",
          columnGap: "2",
          minHeight: "10",
          paddingInline: "2",
          borderRadius: "l2",
        },
        indicator: {
          marginEnd: "0",
          display: "inline-flex",
          alignItems: "center",
          justifyContent: "center",
          boxSize: "6",
          color: "fg.default",
          "& svg": { width: "5", height: "5" },
          "& path": { fill: "currentColor" },
        },
      },
    },
  },
});
